import React, { Component } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    Typography,
    Box,
    Grid,
    Button,
    CircularProgress,
    Autocomplete,
    TextField
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Opcional: ícone para o botão
import InspectorCelular from './InspectorCelular';
import { apiUrl } from '../../comp/ApiUrl';
import { toast } from 'react-toastify';
import { WithRouter } from '../../comp/WithRouter';

class ChecklistEntrada extends Component {
    constructor(props) {
        super(props);

        this.componentes = [
            "Botão Power",
            "Botão Volume",
            "Botão Home",
            "Vibra",
            "Touch ID",
            "Conexão Wifi",
            "Conector de Carga",
            "Sensor de Luminosidade",
            "Microfone",
            "Alto Falante",
            "Campainha",
            "Câmera Frontal",
            "Câmera Traseira",
            "Conector de Chip",
            "Conector Fone de Ouvido",
            "Parafusos Aparentes",
            "Touch screen",
            "LCD",
            "Risco de quebrar a tela",
            "Risco Tampa Traseira (Quebra/Descascar)",
            "Não visto ligado"
        ];

        // Lista fictícia de clientes. Substitua pelos dados da sua API futuramente.
        this.clientesMock = [];

        this.state = {
            clienteSelecionado: null, // Armazenará o objeto do cliente escolhido
            checklist: this.componentes.reduce((acc, comp) => {
                acc[comp] = null;
                return acc;
            }, {}),
            clientesOpcoes: [],
            inspectorCelular: null, // Armazenará os dados vindos do canvas e checkboxes visuais
            enviando: false // Controle de loading para o botão
        };
    }

    handleCheckboxChange = (componente, tipo) => {
        this.setState((prevState) => {
            const currentVal = prevState.checklist[componente];
            return {
                checklist: {
                    ...prevState.checklist,
                    [componente]: currentVal === tipo ? null : tipo
                }
            };
        }, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.checklist);
            }
        });
    };

    // Função responsável por juntar os dados e disparar a requisição HTTP
    handleSalvar = async () => {
        const { checklist, inspectorCelular, clienteSelecionado, aparelho, imei } = this.state;

        // Validação básica para garantir que um cliente foi selecionado antes de salvar
        if (!clienteSelecionado) {
            alert('Por favor, selecione um cliente antes de salvar o checklist.');
            return;
        }

        // Monta o payload final combinando o cliente, a tabela e a inspeção visual do celular
        const payload = {
            cliente: clienteSelecionado,
            aparelho: aparelho,
            imei: imei,
            checklistTabela: checklist,
            inspecaoVisual: inspectorCelular
        };

        this.setState({ enviando: true });

        try {
            const response = await fetch(`${apiUrl}/checklist/set`, {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Adicione cabeçalhos de autenticação aqui se o seu sistema exigir, ex:
                    // 'Authorization': `Bearer ${seuToken}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Erro no servidor: ${response.status}`);
            }

            const data = await response.json();

            toast.success('Checklist salvo com sucesso!');
            this.props.navigate('/checklist');


        } catch (error) {
            console.error('Erro ao enviar dados:', error);
            alert('Falha ao salvar o checklist. Por favor, tente novamente.');
        } finally {
            this.setState({ enviando: false });
        }
    };

    buscarClientesDoBackend = async (busca) => {
        if (!busca) {
            this.setState({ clientesOpcoes: [] });
            return;
        }

        this.setState({ loading: true });

        try {
            // Substitua pela URL da sua API
            const response = await fetch(`${apiUrl}/checklist/search/clients?t=${encodeURIComponent(busca)}`, {
                credentials: 'include',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // Adicione cabeçalhos de autenticação aqui se o seu sistema exigir, ex:
                    // 'Authorization': `Bearer ${seuToken}`
                }
            });
            const dados = await response.json();

            // Garanta que 'dados' seja uma array de objetos com 'nome' e 'documento'
            this.setState({ clientesOpcoes: dados, loading: false });
        } catch (error) {
            console.error("Erro ao buscar clientes:", error);
            this.setState({ loading: false });
        }
    };



    render() {
        const { checklist, enviando, clienteSelecionado } = this.state;

        return (
            <Box sx={{ p: 1 }}>
                <Grid container spacing={2}>


                    <Grid item size={{ xs: 12 }}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 1, backgroundColor: '#fafafa' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, textTransform: 'uppercase', color: '#555' }}>
                                Identificação do Cliente
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    <Autocomplete
                                        // 1. Usa as opções do estado, não mais o mock estático
                                        options={this.state.clientesOpcoes}

                                        // 2. Controla o estado de carregamento visual
                                        loading={this.state.loading}
                                        loadingText="Carregando clientes..."
                                        noOptionsText="Nenhum cliente encontrado"

                                        getOptionLabel={(option) => {
                                            // Prevenção caso o option venha nulo ou indefinido temporariamente
                                            if (typeof option === 'string') return option;
                                            return option ? `${option.nome} (${option.doc})` : '';
                                        }}

                                        value={this.state.clienteSelecionado}
                                        onChange={(event, newValue) => {
                                            this.setState({ clienteSelecionado: newValue });
                                        }}

                                        // 3. Captura o que o usuário digita e dispara a busca
                                        inputValue={this.state.inputValue}
                                        onInputChange={(event, newInputValue) => {
                                            this.setState({ inputValue: newInputValue });

                                            // Dispara a busca no backend
                                            this.buscarClientesDoBackend(newInputValue);
                                        }}

                                        // Mantém o objeto selecionado mesmo que ele suma da lista após nova busca
                                        isOptionEqualToValue={(option, value) => option.doc === value.doc}

                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Buscar ou Selecionar Cliente"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                // Adiciona o spinner de carregamento dentro do input se estiver buscando
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {this.state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    <TextField
                                        label="Aparelho"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) => this.setState({ aparelho: e.target.value })}
                                        value={this.state.aparelho}

                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    <TextField
                                        label="IMEI"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) => this.setState({ imei: e.target.value })}
                                        value={this.state.imei}

                                    />
                                </Grid>
                            </Grid>



                        </Paper>
                    </Grid>

                    {/* COLUNA ESQUERDA: TABELA */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <TableContainer component={Paper} variant="outlined">
                            <Box sx={{ backgroundColor: '#f5f5f5', padding: '10px', textAlign: 'center', borderBottom: '1px solid #ccc' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    Check List - Entrada do Aparelho
                                </Typography>
                            </Box>

                            <Table size="small" aria-label="checklist entrada table">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#fafafa' }}>
                                        <TableCell sx={{ fontWeight: 'bold' }}>COMPONENTES</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', width: '60px' }}>SIM</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', width: '60px' }}>NÃO</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', width: '60px' }}>N/A</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.componentes.map((item) => (
                                        <TableRow key={item} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" sx={{ fontSize: '0.875rem', py: 0.5 }}>
                                                <strong>{item}</strong>
                                            </TableCell>

                                            <TableCell align="center" sx={{ py: 0 }}>
                                                <Checkbox
                                                    checked={checklist[item] === 'SIM'}
                                                    onChange={() => this.handleCheckboxChange(item, 'SIM')}
                                                    size="small"
                                                />
                                            </TableCell>

                                            <TableCell align="center" sx={{ py: 0 }}>
                                                <Checkbox
                                                    checked={checklist[item] === 'NAO'}
                                                    onChange={() => this.handleCheckboxChange(item, 'NAO')}
                                                    size="small"
                                                />
                                            </TableCell>

                                            <TableCell align="center" sx={{ py: 0 }}>
                                                <Checkbox
                                                    checked={checklist[item] === 'NA'}
                                                    onChange={() => this.handleCheckboxChange(item, 'NA')}
                                                    size="small"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>


                    <Grid item size={{ xs: 12, md: 6 }}>
                        <TableContainer component={Paper} variant="outlined" sx={{ height: '100%', minHeight: '500px' }}>
                            <Box sx={{ backgroundColor: '#f5f5f5', padding: '10px', textAlign: 'center', borderBottom: '1px solid #ccc' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    Condições e termos de responsabilidade
                                </Typography>
                            </Box>
                            <Box sx={{ p: 1 }}>
                                <InspectorCelular onChange={(data) => this.setState({ inspectorCelular: data })} />
                            </Box>
                        </TableContainer>
                    </Grid>
                </Grid>

                {/* CONTAINER DO BOTÃO SALVAR */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, mb: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        startIcon={enviando ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        onClick={this.handleSalvar}
                        disabled={enviando}
                        sx={{ px: 4, py: 1.5, fontWeight: 'bold' }}
                    >
                        {enviando ? 'Salvando...' : 'Salvar Checklist'}
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default WithRouter(ChecklistEntrada);